export default "__VITE_ASSET__Iz$taXSo__"